/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.0.1
 */

import { Fragment } from 'react';

import get from 'lodash/get';

import { icons } from '../../../../../../assets';
import { FlexStyled } from '../../../../../../components/common/Block/Flexbox';
import { ImgStyled } from '../../../../../../components/common/Block/Img';
import { LayoutStyled } from '../../../../../../components/common/Block/Layout';
import ArrowTooltip from '../../../../../../components/common/Tooltip/Tooltip';
import { formatBalance } from '../../../../../../utils/formatText';
import {
    WidgetPersonalAccountBalanceTextStyled,
    WidgetPersonalAccountBalanceTitleStyled,
} from '../styled/WidgetPersonalAccountStyled';
import { IWidgetBalance } from '../types/widgetPersonalAccountType';

export interface IWidgetPersonalAccountBalance {
    balance: IWidgetBalance;
    currency: string;
    isBalanceDanger?: boolean | undefined;
    isCredit?: boolean | undefined;
    name: string;
}

const WidgetPersonalAccountBalance = (props: IWidgetPersonalAccountBalance) => (
    <Fragment>
        <FlexStyled alignItems="center" className="mb-1 widget-personal-account__balance">
            <WidgetPersonalAccountBalanceTitleStyled>
                {props.name}
            </WidgetPersonalAccountBalanceTitleStyled>
            {
                props.balance.description &&
                <LayoutStyled className="ml-1">
                    <ArrowTooltip title={props.balance.description}>
                        <ImgStyled className="small" src={icons.infoBlueIcon}/>
                    </ArrowTooltip>
                </LayoutStyled>
            }
        </FlexStyled>
        <WidgetPersonalAccountBalanceTextStyled
            isBalanceDanger={props.isBalanceDanger}
            isCredit={props.isCredit}
        >
            {`${formatBalance(get(props.balance, 'value', 0))} ${props.currency}`}
        </WidgetPersonalAccountBalanceTextStyled>
    </Fragment>
);

export default WidgetPersonalAccountBalance;
